import { useQuery } from '@tanstack/react-query';

import { useBackerApi } from '../../api';
import { backerKeys } from '../../query-key-factory';
import { ConsumerListResponse } from './lists.types';

const useListConsumerLists = ({
  causeId,
  token,
}: {
  causeId?: string | null;
  token?: string | null;
}) => {
  const BackerApi = useBackerApi();

  const get = async () => {
    const queryParams = new URLSearchParams();
    if (causeId) queryParams.set('cause_id', causeId);
    if (token) queryParams.set('token', token);

    const { data } = await BackerApi.get<ConsumerListResponse>(
      `/consumer/lists?${queryParams.toString()}`
    );

    return data;
  };

  return useQuery({
    queryKey: [...backerKeys.consumer.lists.all, causeId, token],
    queryFn: get,
  });
};

export { useListConsumerLists };
